import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

enum NotifyType {
  sms = 'sms',
  message = 'message',
  do_not = 'do_not',
}

@Component({
  selector: 'app-delivery-status',
  templateUrl: './delivery-status.component.html',
  styleUrls: ['./delivery-status.component.scss']
})
export class DeliveryStatusComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  NotifyType = NotifyType;
  tenant: any = localStorage.getItem('tenant')
  payload: { NotifyUsers: boolean, NotifyUsersBy: Array<number> } = {
    NotifyUsers: true,
    NotifyUsersBy: []
  }
  constructor(
    public dialogRef: MatDialogRef<DeliveryStatusComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    this.getCustomMessage();
  }
  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addNotifyControl();
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }
  initializeForm() {
    let { NotifyUsers } = this.payload;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      custom_message: new FormControl(this.tenant == 'wylo' ? false : true),
      message: new FormControl(""),
    });
    if (this.isDisableNotify) {
      this.addNotifyControl();
    }
  }
  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(this.fb.group({
        id: new FormControl(x.id),
        value: new FormControl(x.value),
        isChecked: new FormControl(x.isChecked),
        disable: new FormControl(this.tenant == 'sl' ? true : false)
      }));
    });
  }
  formSubmit() {
    if (this.isLoading) {
      return;
    }
    if (this.form.valid) {
      this.isLoading = true;
      let payload: { UserID: string, OrderID: string, DeliveryStatus: string, CustomMessage: boolean, Message?: string, NotifyUsers: boolean, NotifyUsersBy: any[] } = {
        UserID: this.props.item.UserID,
        OrderID: this.props.item.OrderID,
        DeliveryStatus: this.props.item.DeliveryStatus,
        CustomMessage: this.form.value.custom_message,
        Message: this.form.value.custom_message ? this.form.value.message : "",
        NotifyUsers: this.form.value.NotifyUsers,
        NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : []
      }
      if(this.tenant == 'sl'){
        delete payload.Message
      } else if(this.tenant == 'ml' || this.tenant == 'ml_qc') {
        payload.CustomMessage = false;
        payload.Message = "";
      }
      // //console.log(JSON.stringify(payload, null, 2))
      this.shippingService.update_delivery_status(payload).subscribe(res => {
        if (res.body.success) {
          this.krollService.get_sales_order_status({ server_location: this.formService.selectedLocation.value });
          this.toast.success(res.body.message);
          // Keep isLoading true until dialog closes to prevent duplicate API calls
          this.dialogRef.close({ payload: payload, response: res.body });
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message);
        }
      }, err => {
        this.isLoading = false;
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
  getCustomMessage() {
    if (this.isDisableNotify) {
      let payload = {
        OrderID: this.props.item.OrderID,
        DeliveryStatus: this.props.item.DeliveryStatus
      }
      this.shippingService.custom_message(payload).subscribe(res => {
        if (res.body.success) {
          this.form.controls.message.setValue(res.body.data);
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message);
        }
      }, err => {
        this.isLoading = false;
      })
    }
    else {
      this.form.controls.NotifyUsers.setValue(false);
      this.form.controls.NotifyUsers.disable();
    }
  }
  get isDisableNotify() {
    return !['Issue with Delivery', 'Pending'].includes(this.props.item.DeliveryStatus);
  }
}
